module.exports = {
          srcSet: __webpack_public_path__ + "images/1914-c9c578092fe4f4915e7a1fe26f0e4e76-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1914-9278b9e3c4024c0925d2cfe3d778985a-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1914-c9c578092fe4f4915e7a1fe26f0e4e76-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1914-9278b9e3c4024c0925d2cfe3d778985a-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1914-c9c578092fe4f4915e7a1fe26f0e4e76-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1914-c9c578092fe4f4915e7a1fe26f0e4e76-320.jpg"},
          
          width: 320,
          height: 251
        }